document.addEventListener('DOMContentLoaded', function () {
  const tabs = Array.from(document.querySelectorAll('.department-tab'));
  const panels = Array.from(document.querySelectorAll('.department-panel'));
  const departmentSelect = document.getElementById('department-select');

  /**
   * Shows the panel and highlights the tab/option for the given department.
   * @param {string} deptHandle - The department metaobject handle.
   */
  function activateDepartment(deptHandle) {
    tabs.forEach(tab => tab.classList.toggle('active', tab.dataset.dept === deptHandle));
    panels.forEach(panel => panel.classList.toggle('active', panel.dataset.dept === deptHandle));

    if (departmentSelect && departmentSelect.value !== deptHandle) {
      departmentSelect.value = deptHandle;
    }
  }

  // Desktop tab clicks
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      activateDepartment(this.dataset.dept);
    });
  });

  // Mobile dropdown change
  if (departmentSelect) {
    departmentSelect.addEventListener('change', function () {
      activateDepartment(this.value);
    });
  }
});